import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto justify-center flex py-12 bg-background-secondary" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row items-center justify-between w-[70%]" }
const _hoisted_3 = { class: "flex gap-3 text-type-primary font-medium" }

import CNavlink from "@/components/c-navlink.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CNavlink, {
        class: "text-type-primary text-xl font-semibold mb-2 sm:mb-0",
        to: "home"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Greenwash Goods")
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(CNavlink, { to: "home" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createTextVNode(" • "),
        _createVNode(CNavlink, { to: "pricing" }, {
          default: _withCtx(() => [
            _createTextVNode("Pricing")
          ]),
          _: 1
        }),
        _createTextVNode(" • "),
        _createVNode(CNavlink, { to: "about" }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        }),
        _createTextVNode(" • "),
        _createVNode(CNavlink, { to: "blog" }, {
          default: _withCtx(() => [
            _createTextVNode("Blog")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})